export var ENTITY_TYPE = /* @__PURE__ */ ((ENTITY_TYPE2) => {
  ENTITY_TYPE2["PUBLIC"] = "Public For-Profit";
  ENTITY_TYPE2["PRIVATE"] = "Private For-Profit";
  ENTITY_TYPE2["NON_PROFIT"] = "Non-Profit";
  ENTITY_TYPE2["SOLE_PROPRIETOR"] = "Sole Proprietor";
  ENTITY_TYPE2["GOVERNMENT"] = "Government";
  return ENTITY_TYPE2;
})(ENTITY_TYPE || {});
export const ENTITY_TYPE_TO_TELNYX_ENTITY = {
  ["Public For-Profit" /* PUBLIC */]: "PUBLIC_PROFIT",
  ["Private For-Profit" /* PRIVATE */]: "PRIVATE_PROFIT",
  ["Non-Profit" /* NON_PROFIT */]: "NON_PROFIT",
  ["Sole Proprietor" /* SOLE_PROPRIETOR */]: "SOLE_PROPRIETOR",
  ["Government" /* GOVERNMENT */]: "GOVERNMENT"
};
export var VERTICAL = /* @__PURE__ */ ((VERTICAL2) => {
  VERTICAL2["REAL_ESTATE"] = "Real Estate";
  VERTICAL2["HEALTHCARE"] = "Healthcare";
  VERTICAL2["ENERGY"] = "Energy";
  VERTICAL2["ENTERTAINMENT"] = "Entertainment";
  VERTICAL2["RETAIL"] = "Retail";
  VERTICAL2["AGRICULTURE"] = "Agriculture";
  VERTICAL2["INSURANCE"] = "Insurance";
  VERTICAL2["EDUCATION"] = "Education";
  VERTICAL2["HOSPITALITY"] = "Hospitality";
  VERTICAL2["FINANCIAL"] = "Financial";
  VERTICAL2["GAMBLING"] = "Gambling";
  VERTICAL2["CONSTRUCTION"] = "Construction";
  VERTICAL2["NGO"] = "NGO";
  VERTICAL2["MANUFACTURING"] = "Manufacturing";
  VERTICAL2["GOVERNMENT"] = "Government";
  VERTICAL2["TECHNOLOGY"] = "Technology";
  VERTICAL2["COMMUNICATION"] = "Communication";
  return VERTICAL2;
})(VERTICAL || {});
export const VERTICAL_TO_TELNYX_VERTICAL = {
  ["Real Estate" /* REAL_ESTATE */]: "REAL_ESTATE",
  ["Healthcare" /* HEALTHCARE */]: "HEALTHCARE",
  ["Energy" /* ENERGY */]: "ENERGY",
  ["Entertainment" /* ENTERTAINMENT */]: "ENTERTAINMENT",
  ["Retail" /* RETAIL */]: "RETAIL",
  ["Agriculture" /* AGRICULTURE */]: "AGRICULTURE",
  ["Insurance" /* INSURANCE */]: "INSURANCE",
  ["Education" /* EDUCATION */]: "EDUCATION",
  ["Hospitality" /* HOSPITALITY */]: "HOSPITALITY",
  ["Financial" /* FINANCIAL */]: "FINANCIAL",
  ["Gambling" /* GAMBLING */]: "GAMBLING",
  ["Construction" /* CONSTRUCTION */]: "CONSTRUCTION",
  ["NGO" /* NGO */]: "NGO",
  ["Manufacturing" /* MANUFACTURING */]: "MANUFACTURING",
  ["Government" /* GOVERNMENT */]: "GOVERNMENT",
  ["Technology" /* TECHNOLOGY */]: "TECHNOLOGY",
  ["Communication" /* COMMUNICATION */]: "COMMUNICATION"
};
export const DEFAULT_BUSINESS_SUPPORT_EMAIL = "success@onetext.com";
